import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Modal } from '../../../theme/Component/Modal';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { FortnightLiquidation } from './FortnightLiquidation';

interface Props {
    idSelector?: number | null;
    onChange: (value: any) => void;
    label?: string;
    render?: string;
}

export const FortnightLiquidationEditor = ({ idSelector, onChange, label, render, }: Props) => {
    const modal = useModal('Incapacidades laborales', MODAL_LG);
    const [selected, setSelected] = useState<any>({});
    const [displayValue, setDisplayValue] = useState(render ?? '');

    useEffect(() => {
        setDisplayValue(render ?? '');

        if (!idSelector) {
            setSelected({});
        }
    }, [idSelector, render]);

    const confirmSelection = () => {
        const selectedId = selected?.HashCode;

        if (!selectedId) {
            toast.error('Debe seleccionar una incapacidad');
            return;
        }

        setDisplayValue(selected.EmployeeName ? `${selected.EmployeeName} - ${selected.Value}` : "");
        onChange(selected);
        modal.close();
    };

    return (
        <>
            {label && label !== ' ' && <label>{label}</label>}
            <div
                className="form-control text-wrap cursor-pointer"
                style={{ minHeight: '35px' }}
                onClick={() => modal.open()}
            >
                {displayValue || <span>Seleccionar...</span>}
            </div>

            <Modal
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={confirmSelection}
                onSubmitLabel="Seleccionar"
            >
                <FortnightLiquidation isModal _onChange={setSelected} />
            </Modal>
        </>
    );
};
